export default __webpack_public_path__ + "/assets/vivi-partner-02-lg.jpg";